export default __webpack_public_path__ + "static/media/running_man_contact.36241447.svg";